import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { Col } from "antd";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { blockCompany } from "services";
import { HTMLAttributes } from "react";

export const BlockCompanyButton: React.FC<HTMLAttributes<HTMLElement>> = observer(({ ...props }) => {
  const { actionModals, companyCard } = useStores();

  const clickHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы действительно хотите заблокировать компанию?"
          successText="Компания заблокирована"
          buttonText="Заблокировать"
          calledQuery={() => blockCompany({ id: companyCard.card.id })}
          onSuccess={() => {
            setTimeout(() => companyCard.updateCardById(companyCard.card.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <Col className={props.className}>
      <CustomButton type="default" onClick={clickHandler} tooltip="Заблокировать компанию">
        Заблокировать
      </CustomButton>
    </Col>
  );
});
